module.exports = __webpack_public_path__ + "img/logo_3_esso.ac3475db.png";